import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const { login } = useAuth();
  const navigate  = useNavigate();
  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [error, setError]       = useState("");
  const [loading, setLoading]   = useState(false);

  const submit = async e => {
    e.preventDefault(); setError(""); setLoading(true);
    try { await login(email, password); navigate("/"); }
    catch (err) { setError(err.message); }
    finally { setLoading(false); }
  };

  return (
    <div style={s.bg}>
      <div style={s.card}>
        <div style={{fontSize:48,marginBottom:8}}>🧵</div>
        <h1 style={s.brand}>Embroideary</h1>
        <p style={s.sub}>Business Panel</p>
        <form onSubmit={submit}>
          <label style={s.label}>Email</label>
          <input style={s.input} type="email" required value={email}
            onChange={e=>setEmail(e.target.value)} placeholder="you@embroideary.in" />
          <label style={s.label}>Password</label>
          <input style={s.input} type="password" required value={password}
            onChange={e=>setPassword(e.target.value)} placeholder="••••••••" />
          {error && <p style={s.err}>{error}</p>}
          <button style={{...s.btn,opacity:loading?.7:1}} type="submit" disabled={loading}>
            {loading?"Signing in…":"Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}

const B="#3D2B1F";
const s={
  bg:   {minHeight:"100vh",background:`linear-gradient(135deg,${B},#6B3A2A)`,
         display:"flex",alignItems:"center",justifyContent:"center",padding:20},
  card: {background:"#fff",borderRadius:16,padding:"44px 36px",width:"100%",maxWidth:380,
         textAlign:"center",boxShadow:"0 20px 60px rgba(0,0,0,0.3)"},
  brand:{margin:0,fontSize:26,fontWeight:700,color:B,fontFamily:"Georgia,serif"},
  sub:  {margin:"4px 0 28px",color:"#888",fontSize:13},
  label:{display:"block",textAlign:"left",fontSize:12,fontWeight:600,color:B,marginBottom:4},
  input:{width:"100%",padding:"10px 12px",borderRadius:7,border:"1px solid #ddd",
         fontSize:13,marginBottom:14,boxSizing:"border-box",fontFamily:"inherit"},
  err:  {color:"#c00",background:"#ffeaea",padding:"8px 12px",borderRadius:6,
         fontSize:12,marginBottom:12},
  btn:  {width:"100%",padding:"11px",background:B,color:"#fff",border:"none",
         borderRadius:8,fontSize:14,fontWeight:600,cursor:"pointer"},
};
